import { Component } from '@angular/core';

@Component({
  selector: 'app-link-expirado-primeiro-acesso',
  imports: [],
  templateUrl: './link-expirado-primeiro-acesso.html',
  styleUrl: './link-expirado-primeiro-acesso.scss'
})
export class LinkExpiradoPrimeiroAcesso {

}
